<template>
    <div>
        <div class="header">
            <a href="/">
                <img src="../images/header-logo.png" alt="Logo" class="logo">
            </a>
        </div>
        <div class="form-signin">
            <img style="width:50%" class="loginLogo" src="../images/login_logo.png"/>
            <h1 class="h3 mb-3 font-weight-normal" style="text-align: center; padding-top:30px">{{ $t('pleaseSignIn') }}</h1>
            <div id="alert" class="text-align: center alert alert-danger alert-dismissible hidden" >
                {{ $t('incorrectUserOrPassword') }}
            </div>
            <label for="inputUserName" class="sr-only">{{ $t('email') }}</label>
            <input @keyup.enter="login" type="userName" id="inputUserName" class="form-control" :placeholder="$t('enterLogin')" v-model="input.userName" required autofocus />
            <label for="inputPassword" class="sr-only">{{ $t('password') }}</label>
            <input @keyup.enter="login" type="password" id="inputPassword" class="form-control" :placeholder="$t('enterPassword')" v-model="input.password" required />
            <button class="btn btn-lg btn-primary btn-block" @click="login"> {{ $t('signIn') }}</button>
        </div>
    </div>
</template>

<script>
import authApi from "../api/server/authorization";
import { ResetAuthCache } from '../authCache';

export default {
    name: "Login",
    mounted() {
        this.getLogin();
    },
    data() {
        return {
            input: {
                userName: "",
                password: ""
            }
        };
    },
    computed: {
        redirectTarget() {
            const query = this.$route.query.returnUrl;
            if (query && query.length > 0) 
                return query;
        
            return "/dataspaces";
        }
    },
    methods: {
        async getLogin() {
            ResetAuthCache();

            let login = await authApi.auth();
            if (login.isAuthenticated) {
                this.$router.replace(this.redirectTarget);
            }
        },
        async login() {
            let { userName, password } = this.input;
            let login = await authApi.login(userName, password);
            ResetAuthCache();

            if (login.succeeded) {
                this.$router.replace(this.redirectTarget);
            } else {
                let doc = document.getElementById("alert");
                doc.classList.remove("hidden");
            }
        }
    }
};
</script>